var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 18 17" }, props),
    React.createElement("path", { d: "M17.333 6.7l-5.991-.517L9 .667 6.658 6.19.667 6.7l4.55 3.942L3.85 16.5 9 13.392l5.15 3.108-1.358-5.858L17.333 6.7zM9 11.833l-3.133 1.892.833-3.567-2.767-2.4 3.65-.317L9 4.083l1.425 3.367 3.65.316-2.767 2.4.834 3.567L9 11.833z" })
  );
});